module.exports = __webpack_public_path__ + "img/no-data-icon.dc792743.png";